import { render, staticRenderFns } from "./VerTramite.vue?vue&type=template&id=64b8774a&scoped=true"
import script from "./VerTramite.vue?vue&type=script&lang=ts"
export * from "./VerTramite.vue?vue&type=script&lang=ts"
import style0 from "./VerTramite.vue?vue&type=style&index=0&id=64b8774a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8774a",
  null
  
)

export default component.exports